import { ArrowDown, ArrowUp, CornerDownLeft } from 'lucide-react';
import {
  GLOBAL_SEARCH_ACCENT_TEXT_CLASS,
  GLOBAL_SEARCH_KEYCAP_CLASS,
  GLOBAL_SEARCH_SURFACE_CLASS,
} from './constants.js';

/**
 * @param {object} props
 * @param {Record<string, string>} [props.labels]
 * @param {() => void} [props.onAdvancedSearch]
 */
const TopbarGlobalSearchFooter = ({ labels = {}, onAdvancedSearch }) => {
  const navigateLabel = labels.navigate ?? 'Navigate';
  const openLabel = labels.open ?? labels.enter ?? 'Open';
  const advancedSearchLabel = labels.advancedSearch ?? labels.advancedFilters ?? 'Advanced search';

  return (
    <div
      className={[
        'flex shrink-0 items-center justify-between px-4 py-2.5',
        'max-md:hidden',
        GLOBAL_SEARCH_SURFACE_CLASS,
      ].join(' ')}
    >
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1">
          <span className={GLOBAL_SEARCH_KEYCAP_CLASS} aria-hidden>
            <ArrowUp className="h-3.5 w-3.5 text-content-muted dark:text-gray-400" strokeWidth={2} />
          </span>
          <span className={GLOBAL_SEARCH_KEYCAP_CLASS} aria-hidden>
            <ArrowDown className="h-3.5 w-3.5 text-content-muted dark:text-gray-400" strokeWidth={2} />
          </span>
        </div>
        <span className="text-xs font-medium leading-5 text-[#5C5C5C] dark:text-gray-400">
          {navigateLabel}
        </span>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className={GLOBAL_SEARCH_KEYCAP_CLASS} aria-hidden>
            <CornerDownLeft
              className="h-3.5 w-3.5 text-content-muted dark:text-gray-400"
              strokeWidth={2}
            />
          </span>
          <span className="text-xs font-medium leading-5 text-[#5C5C5C] dark:text-gray-400">
            {openLabel}
          </span>
        </div>
        {onAdvancedSearch ? (
          <button
            type="button"
            onClick={onAdvancedSearch}
            className={['text-xs font-medium leading-5', GLOBAL_SEARCH_ACCENT_TEXT_CLASS].join(' ')}
          >
            {advancedSearchLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default TopbarGlobalSearchFooter;
